import { Affix, Button, Card, Form, Space } from "antd";
import { EXPORT_CNF_BILL_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExportCnfBillForm from "./ExportCnfBillForm";

export default function UpdateExportCnfBill(props) {
  const { width, viewMode } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { exportCnfBillId } = useParams();
  const [editInfo, setEditInfo] = useState(null);

  const load = useCallback(
    async (id) => {
      const response = await getData(`${EXPORT_CNF_BILL_LIST_ENDPOINT}/${id}`);
      if (response?.status === 200 && response?.data?.code === 200) {
        setEditInfo(response.data.data);
      } else {
        HandleNotification(
          "error",
          "bottomRight",
          "Failed to load bill",
          response?.data?.message || "",
        );
      }
    },
    [],
  );

  useEffect(() => {
    if (exportCnfBillId) load(exportCnfBillId);
  }, [exportCnfBillId, load]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : width ? `${width}px` : "100%"}` }}
        >
          <Header
            title={`${viewMode ? "View" : "Edit"} Export C&F Bill`}
            subTitle=""
            addLink="/"
            addText=""
            actions={
              <Space>
                <Button
                  danger
                  size="small"
                  onClick={() =>
                    navigate(
                      "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
                    )
                  }
                >
                  {viewMode ? "Back" : "Discard"}
                </Button>
                {!viewMode && (
                  <Button type="primary" size="small" onClick={() => form.submit()}>
                    Update
                  </Button>
                )}
              </Space>
            }
          />
        </Card>
      </Affix>
      <ExportCnfBillForm
        form={form}
        isEdit
        editInfo={editInfo}
        viewMode={viewMode}
        billId={exportCnfBillId}
      />
    </>
  );
}
